<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb"/>
    <div class="flexBox">
      <text-title mainTitle="查看当前车辆信息" subheading="" />
      <div class="header-btn-box">
        <a @click="ToModifyPage">修改</a>
        <a @click="strategyCenter">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">车主姓名：</div>
        <div>{{formData.carOwnerName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">车主手机号：</div>
        <div>{{formData.carOwnerPhone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">车牌号：</div>
        <div>{{formData.carNumber || '无'}}</div>
      </div>
<!--      <div class="form-line">-->
<!--        <div class="line-text">卡号：</div>-->
<!--        <div>{{formData.cardNumber || '无'}}</div>-->
<!--      </div>-->
      <div class="form-line">
        <div class="line-text">车辆品牌：</div>
        <div>{{formData.carBrand || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">车辆颜色：</div>
        <div>{{formData.carColor || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">车辆型号：</div>
        <div>{{formData.carType || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">所属住户：</div>
        <div>{{formData.enterpriseName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">进出有效期：</div>
        <div>{{formData.enterStartTime}} 至 {{formData.enterEndTime}}</div>
      </div>
    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {api} from '../../api/ParkingService'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'

  export default {
    components: {
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'controller-current',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'parking-device-management'
          }, {
            value: '车辆管理'
          }],
        },
        formData: {}
      }
    },
    created () {
      this.deviceCode = this.$route.params.id
      this.getAuthorityByCode()
    },
    methods: {
      getAuthorityByCode () {
        this.$axios.get(`${api.getAuthorityByCode}/${this.deviceCode}`, {})
          .then(res => {
            let data = res.data.data
            if (data.authorizationType === '0') {
              data.authorizationTypeText = '免费'
            } else if (data.authorizationType === '1') {
              data.authorizationTypeText = '收费'
            }
            this.formData = data
          })
          .catch(errorHandler('获取授权数据失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'authorization-management'
        })
      },
      ToModifyPage () {
        this.$router.push({
          path: '/park_server/authorization_modify/' + this.$route.params.id
        })
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 30px 0;
    display: flex;
    justify-content: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/AuthorizationManagement/AuthorizationCurrent.vue